module.exports = __webpack_public_path__ + "img/daikin-paperless.614c56ec.png";